import {autoserialize, autoserializeAs, inheritSerialization} from 'cerialize';
import * as moment from 'moment';
import {MomentTransformer} from '../helpers/moment-transformer';
import { EmailPreference } from './email-preference';
import {ModelBase} from './model-base';
import {User} from './user';

@inheritSerialization(ModelBase)
export class BijbAccount extends ModelBase {
  public static readonly type = 'BijbAccount';
  public readonly type = BijbAccount.type;

  @autoserialize
  public id: number;

  @autoserializeAs('first_name')
  public firstName: string;

  @autoserializeAs('last_name')
  public lastName: string;

  @autoserializeAs('registered')
  public registered: boolean;

  @autoserializeAs('email_address')
  public emailAddress: string;

  @autoserializeAs('email_verified')
  public emailVerified: boolean;

  @autoserializeAs('is_admin')
  public isAdmin: boolean;

  @autoserializeAs(MomentTransformer, 'created_at')
  public createdAt: moment.Moment;

  @autoserializeAs(User, 'users')
  public users: User[];

  @autoserializeAs(EmailPreference, 'email_preferences')
  public emailPreferences: EmailPreference[];

  public name(): string {
    return this.firstName + ' ' + this.lastName;
  }
}
